import { Module } from 'vuex'
import { GigChatState } from './types'
import { getApplication } from '@/api/gigs/applications/applications'
import { getGigOffer } from '@/api/gigs/offers/offers'
import { GigOfferStages } from '@/constants/gig/gigOfferStages'
import GigApplication from '@/models-ts/gigs/GigApplication'
import LoadableModel from '@/models-ts/LoadableModel'
import { RootState } from '@/store'

const getInitialState = (): GigChatState => ({
  application: new LoadableModel(),
  archiving: false,
  decliningOffer: null,
  acceptingOffer: null,
  depositingOffer: null,
})

export default (): Module<GigChatState, RootState> => ({
  namespaced: true,
  state: getInitialState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getInitialState())
    },
    setLoading(state) {
      state.application.loading()
    },
    setLoaded(state, application: GigApplication) {
      state.application.loaded(application)
    },
    setArchiving(state, flag: boolean) {
      state.archiving = flag
    },
    setDecliningOffer(state, flag: number | null) {
      state.decliningOffer = flag
    },
    setAcceptingOffer(state, flag: number | null) {
      state.acceptingOffer = flag
    },
    setDepositingOffer(state, flag: number | null) {
      state.depositingOffer = flag
    },
    updateApplication(state, { id, ...fields }: { id: GigApplication['id'] } & Partial<GigApplication>) {
      if (state.application.value?.id !== id) return

      Object.assign(state.application.value, fields)
    },
    setGigIsDone(state, { id, isDone }: { id: GigApplication['id']; isDone: boolean }) {
      if (state.application.value?.id !== id) return

      state.application.value.isDone = isDone
    },
  },
  actions: {
    async getApplication({ commit }, applicationId: number) {
      commit('setLoading')
      const applicationData = await getApplication(applicationId)
      const application = GigApplication.fromServer(applicationData)
      if (application.offer && application.offer?.stage !== GigOfferStages.NEW) {
        const offer = await getGigOffer(application.offer.id)
        if (offer.relations?.GigJob?.id) {
          application.job = {
            id: offer.relations?.GigJob.id,
            stage: offer.relations.GigJob.stage,
            created_at: offer.relations.GigJob.created_at,
            blockchain: offer.relations.GigJob.blockchain,
            currency: Number(offer.relations.GigJob.currency),
            escrow_balance: offer.relations.GigJob.escrow_balance,
          }
          application.isDone = Boolean(offer.relations.GigJob.is_done)

          let reviews = [] as LX.UserReview[]
          if (offer.relations.GigJob?.relations?.Review) {
            reviews = Array.isArray(offer.relations.GigJob?.relations?.Review)
              ? offer.relations.GigJob?.relations?.Review
              : [offer.relations.GigJob?.relations?.Review]
          } else if (offer.relations?.Review) {
            reviews = Array.isArray(offer.relations?.Review) ? offer.relations?.Review : [offer.relations?.Review]
          }
          application.freelancerLeftReview = reviews.some((item) => item?.from_user_id === offer.freelancer_id)
          application.customerLeftReview = reviews.some((item) => item?.from_user_id === offer.customer_id)
        }
      }
      commit('setLoaded', application)
    },
    // async updateArchiveApplicationFlag({ commit, dispatch, state }, { applicationId, flag }: { applicationId: number; flag: boolean }) {
    //   const application = state.application.value
    //   if (application?.id !== applicationId) return
    //   if (state.archiving) return

    //   commit('setArchiving', true)
    //   try {
    //     const meta = { ...application.meta, archived: flag }
    //     await dispatch(
    //       'jobDetails/setApplicationMeta',
    //       {
    //         jobId: application.job.id,
    //         applicationId: application.id,
    //         meta,
    //       },
    //       { root: true }
    //     )
    //     commit('updateApplication', { id: applicationId, meta })
    //   } finally {
    //     commit('setArchiving', false)
    //   }
    // },
  },
})
